import { render, staticRenderFns } from "./finance-info.vue?vue&type=template&id=03e24eb9&scoped=true"
import script from "./finance-info.vue?vue&type=script&lang=js"
export * from "./finance-info.vue?vue&type=script&lang=js"
import style0 from "./finance-info.vue?vue&type=style&index=0&id=03e24eb9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03e24eb9",
  null
  
)

export default component.exports